const { createBundleTiles } = require('../../shop/tiles/product-tile-factory');

class ProductGroupTileListController {
    constructor(settings, productGroupService) {
        this.settings = settings;
        this.productGroupService = productGroupService;
    }

    $onInit() {
        this.sortOptions = this.productGroupService.getSortOptions();
    }

    title() {
        const description = this.productGroupService.selectedGroup.Description;

        return this.productGroupService.selectedGroupTotalCount != null
            ? `${description} (${this.productGroupService.selectedGroupTotalCount})`
            : description;
    }

    createTiles(products) {
        return {
            items: createBundleTiles(products.items),
            totalRecordCount: products.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType = 'Name') {
        return this.productGroupService.selectProductGroup(this.productGroupId)
            .then(() => this.productGroupService.getProducts({ pageSize, pageNumber, sortType }))
            .then(products => this.createTiles(products));
    }
}

ProductGroupTileListController.$inject = ['Settings', 'ProductGroupService'];

const productGroupTileListComponentDefinition = {
    bindings: {
        productGroupId: '<?',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: ProductGroupTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.title()"
            page-number="$ctrl.pageNumber"
            total-record-count="$ctrl.productGroupService.selectedGroupTotalCount"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">
        </wow-tile-list>
    `,
};

module.exports = {
    ProductGroupTileListController,
    productGroupTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/productgroups/productgroup-tile-list.component.js